/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {subscribeToIncident} from '../api'

export const useMutationSubscribeToIncident = createReactQueryMutationHook('subscribeToIncident', subscribeToIncident)
